import React from 'react'
import { useTranslation } from 'react-i18next'
import { BeWizrLibraryTopic } from '~/models'
import { memo } from '~/ui/component'
import { Chip } from '~/ui/components'
import { colors } from '~/ui/styling'
import { BeWizrTile } from '../bewizr'

export interface Props {
  topic: BeWizrLibraryTopic
}

const BeWizrLibraryTopicTile = memo('BeWizrLibraryTopicTile', (props: Props) => {

  const {topic} = props

  const [t] = useTranslation('bewizr-library')

  //------
  // Rendering

  function render() {
    return (
      <BeWizrTile
        icon='archive'
        title={topic.title}
        image={topic.links.image}
        href={`//bewizr-topics/${topic.slug}`}
        detail={renderDetail()}
        buttonCaption={t('topics.view')}
      />
    )
  }

  function renderDetail() {
    return (
      <Chip

        children={t('items.count', {count: topic.itemCount})}
        backgroundColor={colors.white}
        small
      />
    )
  }

  return render()

})

export default BeWizrLibraryTopicTile